<div
  [ngClass]="{
    'p-0':
      content &&
      ((!content.social && !content.feedback) ||
        (content.social && !content.feedback) ||
        (content.feedback && !content.social))
  }"
  class="flex items-center ml-0 text-center tablet:text-left flex-row flex-none order-1"
  id="mach-homepage-footer-language-selector-container"
>
  <div class="w-px h-9 bg-[#3E414F] hidden tablet:block tablet:ml-24"></div>

  <svg
    width="29"
    height="29"
    viewBox="0 0 29 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="mr-[17px] tablet:ml-[22px] tablet:mr-[12px]"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.685 25.4038C18.7572 24.494 19.9595 23.091 20.8141 21.0095H23.7947C22.3458 23.1079 20.1954 24.6855 17.685 25.4038ZM5.45648 21.0095H8.07097C9.01293 23.065 10.3271 24.4664 11.4942 25.3839C9.01599 24.6564 6.89162 23.0895 5.45648 21.0095ZM11.8369 3.91653C11.4356 4.21213 11.0159 4.55675 10.5947 4.96417C9.8151 5.71773 8.96964 6.75158 8.27275 8.11014H5.65366C7.15159 6.07613 9.32192 4.56747 11.8369 3.91653ZM23.5965 8.10962H20.6144C19.6648 6.09553 18.369 4.74769 17.2387 3.87466C19.8256 4.49957 22.0649 6.02967 23.5965 8.10962ZM21.9445 14.1432C21.8924 12.2195 21.5662 10.5914 21.073 9.22363H24.317C25.1487 10.6909 25.6602 12.3619 25.7475 14.1432H21.9445ZM21.9432 15.2571H25.7463C25.6636 16.925 25.2102 18.498 24.4689 19.8964H21.2157C21.6246 18.5899 21.8942 17.0537 21.9432 15.2571ZM15.1855 19.8964V15.2571H20.8342C20.7806 17.0874 20.4819 18.6206 20.0454 19.8964H15.1855ZM15.1855 25.7288V21.0099H19.6012C18.1998 24.0685 16.0126 25.3428 15.1855 25.7288ZM14.0663 21.0099V25.6905C13.1014 25.2663 10.781 23.9828 9.27844 21.0099H14.0663ZM7.92083 15.2571H14.0688V19.8965H8.79233C8.30833 18.6206 7.98057 17.0874 7.92083 15.2571ZM6.81008 14.143H3.50635C3.59365 12.3617 4.10522 10.6907 4.93689 9.22342H7.77348C7.23741 10.582 6.86981 12.2116 6.81008 14.143ZM14.0688 9.22362V14.1432H7.92083C7.98363 12.1812 8.38032 10.5577 8.96081 9.22362H14.0688ZM14.0689 8.11014H9.52303C10.9582 5.62124 12.9891 4.36683 14.0689 3.84455V8.11014ZM19.906 9.22342C20.4253 10.5529 20.7806 12.1764 20.8357 14.143H15.1855V9.22342H19.906ZM15.1855 8.11016V3.85069C16.2102 4.36532 18.0895 5.59369 19.4006 8.11016H15.1855ZM3.50635 15.2571H6.81161C6.86675 17.0506 7.16848 18.5869 7.62644 19.8964H4.78373C4.04242 18.498 3.58752 16.925 3.50635 15.2571ZM14.625 2.44922C7.8705 2.44922 2.375 7.94472 2.375 14.6992C2.375 21.4537 7.8705 26.9492 14.625 26.9492C21.381 26.9492 26.875 21.4537 26.875 14.6992C26.875 7.94472 21.381 2.44922 14.625 2.44922Z"
      fill="white"
    />
  </svg>

  <a
    role="button"
    tabindex="0"
    #triggerElement
    (click)="onLanguageSelectorClick($event)"
    (keydown.enter)="onLanguageSelectorClick($event)"
    (keydown.space)="onLanguageSelectorClick($event); $event.preventDefault()"
    [attr.data-acdl-action]="'footer:country and language:'"
    [attr.data-acdl-page-section]="
      'footer:country and language:' +
      content?.prefLanguage?.countryName +
      ' - ' +
      content?.prefLanguage?.languageName
    "
    aria-haspopup="true"
    aria-labelledby="lang-selector-label"
    [attr.aria-label]="
      (content?.prefLanguage?.countryName || '') +
      ' - ' +
      (content?.prefLanguage?.languageName || '') +
      '. Link to change the language'
    "
    class="text-body-xs text-[white] hover:text-[white] hover:no-underline cursor-pointer tablet:mr-[24px]"
    href="javascript:void(0);"
    id="mach-homepage-footer-language-selector"
    [style.-webkit-tap-highlight-color]="'transparent'"
  >
    {{ content?.prefLanguage?.countryName }} -
    {{ content?.prefLanguage?.languageName }}
  </a>

  <div
    *ngIf="content.secondaryPrefLanguage"
    class="w-px h-9 bg-[#3E414F] mx-[18px] tablet:mx-0"
  ></div>

  <a
    #selectedLanguage
    role="button"
    tabindex="0"
    *ngIf="content.secondaryPrefLanguage"
    (click)="changeLanguage($event)"
    (keydown.enter)="changeLanguage($event)"
    (keydown.space)="changeLanguage($event); $event.preventDefault()"
    aria-haspopup="true"
    [attr.aria-label]="
      content.secondaryPrefLanguage.languageName +
      '. Link to change the language'
    "
    [attr.data-acdl-action]="
      'footer:country and language:' +
      content?.secondaryPrefLanguage?.languageName
    "
    [attr.data-acdl-page-section]="'footer:country and language'"
    class="text-body-xs text-[white] hover:text-[white] hover:no-underline cursor-pointer tablet:ml-[24px]"
    href="javascript:void(0);"
    id="mach-homepage-footer-language-change-button"
    [style.-webkit-tap-highlight-color]="'transparent'"
  >
    {{ content.secondaryPrefLanguage.languageName }}
    <span class="sr-only">Link to change the language</span>
  </a>

  <span id="lang-selector-label" class="sr-only">
    Link to change the language
  </span>
</div>
